import { render, staticRenderFns } from "./ZoomSliderWrapper.vue?vue&type=template&id=7c5f5a02&scoped=true&"
import script from "./ZoomSliderWrapper.vue?vue&type=script&lang=js&"
export * from "./ZoomSliderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSliderWrapper.vue?vue&type=style&index=0&id=7c5f5a02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5f5a02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins\\workspace\\Apps\\WebViewer\\Dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c5f5a02', component.options)
    } else {
      api.reload('7c5f5a02', component.options)
    }
    module.hot.accept("./ZoomSliderWrapper.vue?vue&type=template&id=7c5f5a02&scoped=true&", function () {
      api.rerender('7c5f5a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\uScope\\js\\extensions\\zoom\\ZoomSliderWrapper.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/zoom/ZoomSliderWrapper.vue
// module id = 531
// module chunks = 0